/* eslint-disable no-useless-escape */
import { isIPv4 } from 'is-ip';

export const required = (value, name) => (value ? undefined : `${name} is required`);

export const requiredArray = (value, name) => (value?.length > 0 ? undefined : `At least one ${name} must be selected`);

export const mustBeNumber = (value, name) =>
  value === undefined || value === '' ? undefined : isNaN(value) ? `${name} must be a number` : undefined;

export const canNotBeNegative = (value, name) =>
  value === undefined || value === '' ? undefined : value < 0 ? `${name} cannot be negative` : undefined;

export const minValue = (min) => (value, name) =>
  value === undefined || value === '' ? undefined : value < min ? `${name} must be at least ${min}` : undefined;

export const maxValue = (max) => (value, name) =>
  value === undefined || value === '' ? undefined : value > max ? `${name} must be at most ${max}` : undefined;

export const minLength = (min) => (value, name) =>
  value === undefined || value === ''
    ? undefined
    : value.length < min
      ? `${name} must be at least ${min} characters`
      : undefined;

export const maxLength = (max) => (value, name) =>
  value === undefined || value === ''
    ? undefined
    : value.length > max
      ? `${name} must be at most ${max} characters`
      : undefined;

export const exactDigitLength = (exact) => (value, name) =>
  value === undefined || value === ''
    ? undefined
    : value.length !== exact
      ? `Please provide a valid ${exact}-digit ${name}`
      : undefined;

export const email = (value, name) =>
  value === undefined || value === ''
    ? undefined
    : /\S+@\S+\.\S+/.test(value)
      ? undefined
      : `Invalid email format in ${name}`;

export const matchPattern = (pattern, errMsg) => (value, name) =>
  value === undefined || value === ''
    ? undefined
    : pattern.test(value)
      ? undefined
      : errMsg || `Invalid format in ${name}`;

export const matchEitherPattern = (patterns) => (value, name) =>
  value === undefined || value === ''
    ? undefined
    : patterns.some((pattern) => pattern.test(value))
      ? undefined
      : `Invalid format in ${name}`;

export const url = (value, name) => {
  const urlPattern =
    /^(https?:\/\/)?((([a-z\d]([a-z\d-]*[a-z\d])*)\.)+[a-z]{2,}|((\d{1,3}\.){3}\d{1,3}))(\:\d+)?(\/[-a-z\d%_.~+]*)*(\?[;&a-z\d%_.~+=-]*)?(\#[-a-z\d_]*)?$/i;
  return value === undefined || value === '' ? undefined : urlPattern.test(value) ? undefined : 'Invalid URL format';
};

export const validPortRange = (value, name) =>
  value === undefined || value === ''
    ? undefined
    : isFinite(value) && value >= 1 && value <= 65535
      ? undefined
      : `${name} must be a valid number between 1 and 65535`;

export const validPhoneNumber = (value, name) => (!value ? 'Please provide a valid phone number' : undefined);

export const validIPv4 = (value, name) =>
  value === undefined || value === '' ? undefined : isIPv4(value) ? undefined : `${name} must be a valid IPv4 address`;

export const matchValue = (matchValue) => (value, name) => (value === matchValue ? undefined : 'Values do not match');

export const hasLowerCase = (value, name) =>
  /[a-z]/.test(value) ? undefined : `${name} must have lower case characters`;

export const hasUpperCase = (value, name) =>
  /[A-Z]/.test(value) ? undefined : `${name} must have upper case characters`;

export const hasNumeric = (value, name) => (/[0-9]/.test(value) ? undefined : `${name} must have numeric values`);

export const hasSpecialChar = (value, name) =>
  /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(value) ? undefined : `${name} must have special characters`;

export const applyValidators = (validators, name) => (value) => {
  for (let validator of validators) {
    const error = validator(value, name);
    if (error) return error;
  }
  return undefined;
};
